// extracted by mini-css-extract-plugin
module.exports = {"blockInput":"block_blockInput__sfzE1","inputWide":"block_inputWide__1zBEl","error":"block_error__1tYSG"};